import { useNavigate } from "react-router-dom";
import Chevron from "../assets/icons/Chevron";
import { PropsWithChildren } from "react";

const DetailViewLayout = ({
  link,
  label,
  children,
  className,
  containerClassName,
  headerAction
}: PropsWithChildren<{
  link?: string;
  label?: string;
  className?: string;
  containerClassName?: string;
  headerAction?: React.ReactNode;
}>) => {
  const navigate = useNavigate();

  return (
    <section className={"py-6 pl-6 pr-6 " + containerClassName}>
      {!!(link && label) && (
        <div className="mb-5 flex items-center justify-between">
          <button
            className="flex items-center gap-4 text-lg font-semibold text-ctb-blue-400"
            onClick={() => navigate(link)}
          >
            <Chevron className="w-5 rotate-90 stroke-ctb-blue-400" />
            <p>{label}</p>
          </button>
          {headerAction}
        </div>
      )}

      <div className={className}>{children}</div>
    </section>
  );
};

export default DetailViewLayout;
